import {
  pageTitle,
  pageTitleContainer,
  pageTitleContainerBase,
} from "../styles.css";
import { PropsWithChildren, useEffect, useState } from "react";
import { PageProps } from "gatsby";
import { heroSectionContainer } from "../../../mdx-pages/components/layout/hero-section/styles.css";
import classNames from "classnames";

export const PageTitle = ({
  props,
  className,
}: PropsWithChildren<{
  className?: string;
  props: PageProps<unknown, { frontmatter?: { title?: string } }>;
}>) => {
  const title = props.pageContext.frontmatter?.title;
  const { pathname } = props.location;
  const [scrollPast, setScrollPast] = useState(false);

  useEffect(() => {
    const target = document.querySelector(`.${heroSectionContainer}`);
    if (!target) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setScrollPast(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0,
      } as IntersectionObserverInit,
    );

    observer.observe(target);
    return () => {
      observer.unobserve(target);
    };
  }, [pathname]);

  return (
    <div
      className={classNames(pageTitleContainerBase, className, {
        [pageTitleContainer.withBackground]: scrollPast,
      })}
    >
      <div className={pageTitle}>{title}</div>
    </div>
  );
};
